
export { default as Login } from "./auth/login/Login";
export { default as Verify } from "./auth/verify/Verify";
export { default as DiscussionAdd } from "./discussion/add/DiscussionAdd";
export { default as DiscussionDetail } from "./discussion/detail/DiscussionDetail";
export { default as DiscussionList } from "./discussion/list/DiscussionList";
export { default as Dashboard } from "./dashboard/Dashboard";
export { default as AdminHomepageHero } from "./dashboard/homepage_hero/AdminHomepageHero";
export { default as AdminImageGuidelines } from "./dashboard/image_guidelines/AdminImageGuidelines";
export { default as AdminHomepageCarousels } from "./dashboard/homepage_carousels/AdminHomepageCarousels";
export { default as AdminDoctors } from "./dashboard/doctors/AdminDoctors";
export { default as AdminUsers } from "./dashboard/users/AdminUsers";
export { default as DoctorList } from "./doctor/list/DoctorList";
export { default as Home } from "./home/Home";
export { default as NotFound } from "./not_found/NotFound";
export { default as PaymentDetail } from "./payment/detail/PaymentDetail";
export { default as PaymentList } from "./payment/list/PaymentList";
export { default as AboutUs } from "./about/AboutUs";
export { default as ContactUs } from "./contact/ContactUs";
export { default as PrivacyAndPolicy } from "./privacy_and_policy/PrivaryAndPolicy";
export { default as ProfileDetail } from "./profile/detail/ProfileDetail";
export { default as ProfileEdit } from "./profile/edit/ProfileEdit";
export { default as ProfileEditDoctor } from "./profile/edit_doctor/ProfileEditDoctor";
export { default as PublicationAdd } from "./publication/add/PublicationAdd";
export { default as PublicationDetail } from "./publication/detail/PublicationDetail";
export { default as PublicationEdit } from "./publication/edit/PublicationEdit";
export { default as PublicationList } from "./publication/list/PublicationList";
export { default as TagDetail } from "./tag/detail/TagDetail";
export { default as VisitDoctor } from "./visit/doctor/VisitDoctor";
export { default as VisitDoctorReserve } from "./visit/doctor_reserve/VisitDoctorReserve";
export { default as AdminWebinarAdd } from "./webinar/admin_add/AdminWebinarAdd";
export { default as AdminWebinarList } from "./dashboard/webinar_admin_list/AdminWebinarList";
export { default as AdminWorkshopList } from "./dashboard/workshop_admin_list/AdminWorkshopList";
export { default as AdminSubscriptionPlans } from "./dashboard/subscriptions/AdminSubscriptionPlans";
export { default as AdminVideoClips } from "./dashboard/video_clips/AdminVideoClips";
export { default as VideoClipList } from "./video_clip/VideoClipList";
export { default as VideoClipDetail } from "./video_clip/detail/VideoClipDetail";
export { default as SubscriptionList } from "./subscription/SubscriptionList";
export { default as WebinarAdd } from "./webinar/add/WebinarAdd";
export { default as WebinarDetail } from "./webinar/detail/WebinarDetail";
export { default as WebinarEdit } from "./webinar/edit/WebinarEdit";
export { default as WebinarList } from "./webinar/list/WebinarList";
export { default as WebinarPurchase } from "./webinar/purchase/WebinarPurchase";
export { default as WorkshopAdd } from "./workshop/add/WorkshopAdd";
export { default as WorkshopDetail } from "./workshop/detail/WorkshopDetail";
export { default as WorkshopEdit } from "./workshop/edit/WorkshopEdit";
export { default as EpisodeAdd } from "./workshop/episode_add/EpisodeAdd";
export { default as EpisodeEdit } from "./workshop/episode_edit/EpisodeEdit";
export { default as WorkshopList } from "./workshop/list/WorkshopList";
export { default as WorkshopPurchase } from "./workshop/purchase/WorkshopPurchase";
